class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('.cart-notification');
    this.overlay = this.notification.parentElement;
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.overlay.classList.add("active");
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.overlay.classList.remove("active");

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      // {
      //   id: 'cart-notification-product',
      //   selector: `#cart-notification-product-${this.productId}`,
      // },
      // {
      //   id: 'cart-notification-button'
      // },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    // if (target !== this.notification && !target.closest('cart-notification') ) {
      if( target.classList.contains("modal-overlay") ) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }

  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// product pop up
class ProductPopUp extends HTMLElement {
  constructor() {
    super();

    this.popup = document.getElementById('product-popup');
    this.overlay = this.popup.parentElement;
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.popup.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    if( window.location.href.includes("/products/")  ){
      // this.open();
    }
  }

  open() {
    this.popup.classList.add('animate', 'active');
    this.overlay.classList.add("active");
    this.popup.addEventListener('transitionend', () => {
      this.popup.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.popup.classList.remove('active');
    this.overlay.classList.remove("active");

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }


  // getSectionsToRender() {
  //   return [
  //     // {
  //     //   id: 'cart-notification-product',
  //     //   selector: `#cart-notification-product-${this.productId}`,
  //     // },
  //     // {
  //     //   id: 'cart-notification-button'
  //     // },
  //     {
  //       id: 'cart-icon-bubble'
  //     }
  //   ];
  // }


  handleBodyClick(evt) {
    const target = evt.target;
    // if (target !== this.notification && !target.closest('cart-notification') ) {
      if( target.classList.contains("modal-overlay") ) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }

  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-popup', ProductPopUp);

